(() => {
    const $ = (selector, root = document) => root.querySelector(selector);
    const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

    const onDomReady = (fn) => {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn, { once: true });
            return;
        }
        fn();
    };

    const normalize = (value = '') =>
        String(value)
            .toLowerCase()
            .trim();

    const debounce = (fn, wait = 120) => {
        let timerId;
        return (...args) => {
            clearTimeout(timerId);
            timerId = setTimeout(() => fn(...args), wait);
        };
    };

    onDomReady(() => {
        const searchInput = $('[data-lottery-search]');
        const list = $('[data-lottery-list]');

        if (!searchInput || !list) return;

        const clearBtn = $('[data-lottery-clear]');
        const emptyState = $('[data-lottery-empty]');

        const getItems = () => $$('[data-lottery-item]', list);

        const setEmptyStateVisible = (isVisible) => {
            if (!emptyState) return;
            emptyState.classList.toggle('d-none', !isVisible);
        };

        const applyFilter = (query) => {
            const q = normalize(query);
            let visibleCount = 0;

            getItems().forEach((item) => {
                const text = normalize(item.getAttribute('data-lottery-search-text'));
                const matches = !q || text.includes(q);

                item.classList.toggle('collapse', !matches);

                if (matches) {
                    item.classList.remove('is-hidden');
                    visibleCount += 1;
                }
            });

            setEmptyStateVisible(visibleCount === 0);
        };

        const onInput = debounce((e) => applyFilter(e.target.value), 120);

        searchInput.addEventListener('input', onInput);

        if (clearBtn) {
            clearBtn.addEventListener('click', () => {
                searchInput.value = '';
                applyFilter('');
                searchInput.focus();
            });
        }

        applyFilter('');
    });
})();
